var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "column is-3-desktop is-2-fullhd is-hidden-touch" },
    [
      _c("div", { staticClass: "card sticky-column" }, [
        _c("div", { staticClass: "card-image" }, [
          _c("figure", { staticClass: "image" }, [
            _vm.file.preview_uri
              ? _c("img", {
                  staticClass: "image",
                  attrs: {
                    src: _vm.file.preview_uri
                      ? _vm.file.preview_uri
                      : "/statics/default-document.png",
                    alt: "Previsualización",
                  },
                })
              : _c("img", {
                  staticClass: "image",
                  attrs: {
                    src:
                      _vm.file.tipo_documento_id == "carpeta"
                        ? "/statics/default-folder.png"
                        : "/statics/default-document.png",
                    alt: "Previsualización",
                  },
                }),
          ]),
        ]),
        _vm._v(" "),
        _c("hr", { staticClass: "my-0" }),
        _vm._v(" "),
        _c("div", { staticClass: "card-content" }, [
          _vm.currentFolder
            ? _c("p", { staticClass: "title is-5 name-file" }, [
                _vm._v(
                  _vm._s(
                    _vm.currentFolder.id == _vm.file.id
                      ? _vm.getCurrentFolderReadableName(_vm.currentFolder)
                      : _vm.file.nombre
                  )
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "content" }, [
            _c("p", [
              _c("b", [_vm._v("Propietario")]),
              _vm._v(" "),
              _c("br"),
              _vm.loadingOwner
                ? _c("span", { staticClass: "is-size-7" }, [
                    _c("i", { staticClass: "fas fa-sync fa-spin" }),
                    _vm._v("  Cargando"),
                  ])
                : _c("span", { staticClass: "is-size-7" }, [
                    _vm._v(_vm._s(_vm.theOwnersName)),
                  ]),
            ]),
            _vm._v(" "),
            _vm.isDocument
              ? _c(
                  "p",
                  [
                    _c("b", [_vm._v("Versión")]),
                    _vm._v(" "),
                    _c("b-tag", { attrs: { type: "is-primary" } }, [
                      _vm._v(
                        _vm._s(
                          _vm.file.ultima_version
                            ? _vm.file.ultima_version.orden + 1
                            : 1
                        )
                      ),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("p", [
              _c("b", [_vm._v("Fecha creación")]),
              _vm._v(" "),
              _c("br"),
              _c("span", { staticClass: "is-size-7" }, [
                _vm._v(_vm._s(_vm.file.created_at)),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("ul", [
            _vm.isDocument
              ? _c(
                  "li",
                  {
                    class: _vm.canSign ? "my-1" : "my-1 disabled-option",
                    on: {
                      click: function ($event) {
                        _vm.canSign
                          ? _vm.addToPila()
                          : _vm.openWarningSnackBar(_vm.messageSnackbar)
                      },
                    },
                  },
                  [
                    _c(
                      "a",
                      {
                        class: _vm.canSign
                          ? "has-text-info"
                          : "disabled-option",
                      },
                      [
                        _c("i", { staticClass: "fas fa-plus fa-fw" }),
                        _vm._v(" "),
                        _c("i", { staticClass: "fas fa-inbox fa-fw" }),
                        _vm._v(" Agregar para firmar\n          "),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isDocument
              ? _c(
                  "li",
                  {
                    class: _vm.canDownload ? "my-1" : "my-1 disabled-option",
                    on: {
                      click: function ($event) {
                        _vm.canDownload
                          ? _vm.download()
                          : _vm.openWarningSnackBar(_vm.messageSnackbar)
                      },
                    },
                  },
                  [
                    _c(
                      "a",
                      {
                        class: _vm.canDownload
                          ? "has-text-info"
                          : "disabled-option",
                      },
                      [
                        _c("i", { staticClass: "fas fa-download fa-fw" }),
                        _vm._v(" Descargar\n          "),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isDocument
              ? _c(
                  "li",
                  {
                    class: _vm.canPreview ? "my-1" : "my-1 disabled-option",
                    on: {
                      click: function ($event) {
                        _vm.canPreview
                          ? _vm.previewDocument()
                          : _vm.openWarningSnackBar(_vm.messageSnackbar)
                      },
                    },
                  },
                  [
                    _c(
                      "a",
                      {
                        class: _vm.canPreview
                          ? "has-text-info"
                          : "disabled-option",
                      },
                      [
                        _c("i", { staticClass: "fas fa-glasses fa-fw" }),
                        _vm._v(" Previsualizar\n          "),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "li",
              {
                class: _vm.canMove ? "my-1" : "my-1 disabled-option",
                on: {
                  click: function ($event) {
                    _vm.canMove
                      ? _vm.moveDocument()
                      : _vm.openWarningSnackBar(_vm.messageSnackbar)
                  },
                },
              },
              [
                _c(
                  "a",
                  { class: _vm.canMove ? "has-text-info" : "disabled-option" },
                  [
                    _c("i", { staticClass: "fas fa-dolly fa-fw" }),
                    _vm._v(" Mover\n          "),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            !_vm.isRecibo
              ? _c(
                  "li",
                  {
                    class: _vm.canRename ? "my-1" : "my-1 disabled-option",
                    on: {
                      click: function ($event) {
                        _vm.canRename
                          ? _vm.renameDocument()
                          : _vm.openWarningSnackBar(_vm.messageSnackbar)
                      },
                    },
                  },
                  [
                    _c(
                      "a",
                      {
                        class: _vm.canRename
                          ? "has-text-info"
                          : "disabled-option",
                      },
                      [
                        _c("i", { staticClass: "fas fa-terminal fa-fw" }),
                        _vm._v(" Renombrar\n          "),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isFolder
              ? _c(
                  "li",
                  {
                    staticClass: "my-1",
                    on: {
                      click: function ($event) {
                        return _vm.openPermissions()
                      },
                    },
                  },
                  [_vm._m(0)]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isFolder
              ? _c(
                  "li",
                  {
                    class: _vm.canSetRootFolder
                      ? "my-1"
                      : "my-1 disabled-option",
                    on: {
                      click: function ($event) {
                        _vm.canSetRootFolder
                          ? _vm.setRootFolder()
                          : _vm.openWarningSnackBar(_vm.messageSnackbar)
                      },
                    },
                  },
                  [
                    _c(
                      "a",
                      {
                        class: _vm.canSetRootFolder
                          ? "has-text-info"
                          : "disabled-option",
                      },
                      [
                        _c("i", { staticClass: "fas fa-hammer fa-fw" }),
                        _vm._v(" Definir como carpeta raiz\n          "),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "li",
              {
                class: _vm.canDelete ? "my-4" : "my-4 disabled-option",
                on: {
                  click: function ($event) {
                    _vm.canDelete
                      ? _vm.deleteDocument()
                      : _vm.openWarningSnackBar(_vm.messageSnackbar)
                  },
                },
              },
              [
                _c(
                  "a",
                  {
                    class: _vm.canDelete
                      ? "has-text-danger"
                      : "disabled-option",
                  },
                  [
                    _c("i", { staticClass: "fas fa-trash fa-fw" }),
                    _vm._v(" Eliminar\n          "),
                  ]
                ),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card-footer" }, [
          _c(
            "a",
            {
              class: _vm.canOpenFile
                ? "has-text-primary card-footer-item"
                : "card-footer-item disabled-option",
              on: {
                click: function ($event) {
                  _vm.canOpenFile
                    ? _vm.openFile()
                    : _vm.openWarningSnackBar(_vm.messageSnackbar)
                },
              },
            },
            [
              _c("i", { staticClass: "fas fa-external-link-alt fa-fw" }),
              _vm._v(" Abrir\n      "),
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "has-text-dark card-footer-item",
              on: {
                click: function ($event) {
                  return _vm.closeSidebar()
                },
              },
            },
            [
              _vm._v("\n        Ocultar "),
              _c("i", { staticClass: "fas fa-angle-double-right fa-fw" }),
            ]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("a", { staticClass: "has-text-info" }, [
      _c("i", { staticClass: "fas fa-users-cog fa-fw" }),
      _vm._v(" Gestionar permisos\n          "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }